// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__12GRn","noInteraction":"EventWrapper_noInteraction__31xZ5"};